<template>
  <div id="app">
    <NavBar />
    <AsideMenu v-if="false" :menu="menu" />
    <transition
      name="fade"
      mode="out-in"
      @beforeLeave="beforeLeave"
      @enter="enter"
      @afterEnter="afterEnter"
    >
      <div style="min-height: 400px" class="section">
        <router-view />
      </div>
    </transition>
    <FooterBar />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import NavBar from '@/components/NavBar'
import AsideMenu from '@/components/AsideMenu'
import FooterBar from '@/components/FooterBar'

export default {
  name: 'Home',
  components: {
    FooterBar,
    AsideMenu,
    NavBar,
  },
  // watch: {
  //   authenticated(value) {
  //     this.setAsideBar(false)
  //   }
  // },
  computed: {
    ...mapGetters(['authenticated']),
    menu() {
      return []
    },
  },

  created() {
    this.isAuthenticated()
    this.setAsideBar(false)
  },
  methods: {
    ...mapActions(['isAuthenticated']),
    setAsideBar(value) {
      const root = document.getElementsByTagName('html')[0]
      let classes = root.className.split(' ')
      if (value) {
        if (!classes.includes('has-aside-expanded')) {
          classes.push('has-aside-expanded')
          root.className = classes.join(' ')
        }
      } else {
        if (classes.includes('has-aside-expanded')) {
          classes = classes.filter((item) => item === 'has-aside-expanded')
          root.className = classes.join(' ')
        }
      }
    },
    beforeLeave(element) {
      this.prevHeight = getComputedStyle(element).height
    },
    enter(element) {
      const { height } = getComputedStyle(element)

      element.style.height = this.prevHeight

      setTimeout(() => {
        element.style.height = height
      })
    },
    afterEnter(element) {
      element.style.height = 'auto'
    },
  },
}
</script>

<style>
html,
body {
  margin: 0;
  padding: 0;
  height: 100%;
}

#app {
  min-height: 100%;
  position: relative;
}

.footer {
  width: 100%;
  position: absolute;
  bottom: -30px;
  left: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.3s;
  transition-property: height, opacity;
  transition-timing-function: ease-in-out;
  overflow: hidden;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}
</style>
